import { CurrentUserType } from '../graphql/getCurrentUser';
import { USER_TYPES } from '../typesInterfacesEnums/enums';

export default function getUserName(user: CurrentUserType | null) {
  if (user) {
    if (user.userType === USER_TYPES.teacher) {
      return user.firstName;
    } else {
      if (user.displayName) {
        return user.displayName;
      }
      return user.email;
    }
  } else {
    return 'Loading...';
  }
}
